<template>
  <div v-loading="optLoading" class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          :class="['tabItem', active === 0 ? 'active' : '']"
          @click="changeType(0)"
        >
          客户
        </span>
        <span
          :class="['tabItem', active === 1 ? 'active' : '']"
          @click="changeType(1)"
        >
          代理
        </span>
      </div>
      <div class="opt">
        <div
          v-if="filterList.invoiceDate && isActive"
          class="checkDate flex_c_c"
        >
          查询时间：{{
            filterList.invoiceDate[0] + "~" + filterList.invoiceDate[1]
          }}
        </div>
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
              :default="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="filterList.search"
            placeholder="请输入账单号搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <!-- <div
          v-permissson="'generate'"
          class="generate flex_c_c"
          @click="dialogVisible1 = true"
        >
          <img src="@/assets/images/const/generate.png" alt="生成账单" />
          生成账单
        </div> -->
        <div v-permissson="'derive'" class="derive flex_c_c" @click="derive">
          <img src="@/assets/images/const/derive.png" alt="导出" />
          导出
        </div>
        <BaseFilter
          :isActive="isActive"
          :width="466"
          @sendFilter="sendFilter"
          @reset="reset"
        >
          <div class="filter">
            <el-form ref="form" :model="filterList" label-width="70px">
              <!-- <el-form-item label="账单日期">
                <el-date-picker
                  v-model="filterList.invoiceDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item> -->
              <el-form-item label="账单状态">
                <el-select
                  v-model="filterList.status"
                  style="width: 320px"
                  filterable
                  placeholder="请选择"
                >
                  <el-option label="未审核" value="0"></el-option>
                  <el-option label="已审核" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务员">
                <el-select
                  v-model="filterList.saleIds"
                  style="width: 320px"
                  filterable
                  placeholder="请选择"
                  multiple
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户">
                <el-select
                  v-model="filterList.companyId"
                  style="width: 320px"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="账单号">
                <base-muti-input
                  ref="baseMutiInput"
                  v-model="filterList.search"
                  style="width: 320px"
                ></base-muti-input>
              </el-form-item> -->
            </el-form>
          </div>
        </BaseFilter>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="{
          ...tableData,
          fileds,
        }"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :loading="loading"
        :isEmptyBorder="true"
        :pageSizes="[20, 30, 50, 100]"
        @handlePageChange="handlePageChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChange="sortChange"
        @dblclick="(row) => detail('FYCX', row)"
      >
        <template slot="statusName" slot-scope="row">
          <div v-if="row.scope.status === 0" class="flex_c_c status red">
            {{ row.scope.statusName }}
          </div>
          <div v-else class="flex_c_c status green">
            {{ row.scope.statusName }}
          </div>
        </template>
        <template slot="verifedAmount" slot-scope="row">
          {{ row.scope.verifedAmount || 0 }}USD
          <i v-if="+row.scope.verifedAmount > 0" style="color: rgb(18, 88, 188);" class="el-icon-link" @click="showVerifedLog(row.scope)" />
        </template>
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-if="!row.scope.status"
                  v-permissson="'audit'"
                  class="opt-item"
                  @click="audit(row.scope)"
                >审核</el-button
                >
                <el-button
                  v-if="row.scope.status"
                  v-permissson="'reAudit'"
                  class="opt-item"
                  @click="reAudit(row.scope)"
                >反审核</el-button
                >
                <!-- <el-button
                  v-if="!row.scope.status"
                  v-permissson="'deleteRow'"
                  class="opt-item"
                  @click="deleteRow(row.scope)"
                >删除</el-button
                > -->
              </div>
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
        <template #custom-total>
          <div class="custom-total">
            <div style="display: flex">
              <div class="select">已选 {{ selectionItem.length }} 项</div>
              <div class="total">
                账单金额：<span>{{ totalAmount }} USD</span>
              </div>
            </div>
          </div>
        </template>
      </BaseTable>
    </div>
    <GenerateBillDialog
      :dialogVisible="dialogVisible1"
      :type="active"
      @cancel="dialogVisible1 = false"
      @ok="ok"
    ></GenerateBillDialog>
    <ShowPayableSupplyDetailDialog :rowData="rowData" :dialogFormVisible="dialogVisible2" @cancel="dialogVisible2 = false"></ShowPayableSupplyDetailDialog>
    <VerifedLogByBillDrawer
      :drawer="drawer"
      :rowData="rowData"
      :typeActive="+active"
      @close="drawer = false"
    >
    </VerifedLogByBillDrawer>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput.vue')
import GenerateBillDialog from './components/GenerateBillDialog'
import ShowPayableSupplyDetailDialog from './components/ShowPayableSupplyDetailDialog'
import VerifedLogByBillDrawer from './components/VerifedLogByBillDrawer'
import { getRouteByCode } from '@/utils/common'
import {
  getPages,
  reviewInvoice,
  antiReviewInvoice,
  deleteCustomerInvoice,
  getSupplierPages,
  reviewSupplierInvoice,
  antiSupplierReviewInvoice,
  deleteSupplierInvoice
} from '@/api/fee'
import { getSaleList } from '@/api/system'
import { derive } from '@/utils/common'
import { getRecentMonthDate } from '@/utils/common'
import { mapGetters } from 'vuex'
import { myMixins } from '@/mixins'
export default {
  name: 'BillWnquiry',
  components: {
    BaseTable,
    BaseFilter,
    BaseMutiInput,
    GenerateBillDialog,
    ShowPayableSupplyDetailDialog,
    VerifedLogByBillDrawer
  },
  mixins: [myMixins],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: {
        fileds: [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'companyId',
            label: '客户',
            width: '230',
            formatter: (row) => {
              if (this.active === 0) {
                const item = this.companyDrapdown.find(
                  (a) => a.value === row.companyId,
                )
                if (item) {
                  return item.label
                } else {
                  return ''
                }
              } else {
                return row.supplierName
              }
            }
          },
          {
            filed: 'invoiceNumber',
            label: '账单号码',
            width: '140'
          },
          // {
          //   filed: 'invoiceDate',
          //   label: '账单日期',
          //   width: '220',
          //   formatter: (row) => {
          //     if (row.startDate && row.endDate) {
          //       return row.startDate.slice(0, row.startDate.length - 9) + ' - ' + row.endDate.slice(0, row.endDate.length - 9)
          //     } else {
          //       return ''
          //     }
          //   }
          // },
          {
            filed: 'invoiceAmount',
            label: '账单金额',
            width: '140',
            formatter: (row) =>
              row.invoiceAmount ? row.invoiceAmount + ' USD' : '0 USD'
          },
          {
            filed: 'verifedAmount',
            label: '核销金额',
            width: '140',
            isCustom: true
          },
          {
            filed: 'statusName',
            label: '状态',
            width: '120',
            isCustom: true
          },
          {
            filed: 'beforeBalance',
            label: '前期余额',
            width: '160',
            formatter: (row) =>
              row.beforeBalance ? row.beforeBalance + ' USD' : '0 USD'
          },
          {
            filed: 'clearencePickAmount',
            label: '本期清提',
            width: '150',
            formatter: (row) =>
              row.clearencePickAmount
                ? row.clearencePickAmount + ' USD'
                : '0 USD'
          },
          // {
          //   filed: 'deliveryAmount',
          //   label: '本期派送',
          //   width: '150',
          //   formatter: (row) =>
          //     row.deliveryAmount ? row.deliveryAmount + ' USD' : '0 USD'
          // },
          {
            filed: 'otherServiceAmount',
            label: '本期其它业务',
            width: '150',
            formatter: (row) =>
              row.otherServiceAmount
                ? row.otherServiceAmount + ' USD'
                : '0 USD'
          },
          {
            filed: 'currentBalance',
            label: '当前余额',
            width: '140',
            formatter: (row) =>
              row.currentBalance ? row.currentBalance + ' USD' : '0 USD'
          },
          {
            filed: 'createdName',
            label: '创建人',
            width: '100'
          },
          {
            filed: 'createdOn',
            label: '创建日期',
            width: '150',
            isSort: true,
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 3)
                : ''
          },
          {
            filed: 'saleName',
            label: '销售员',
            width: '180'
          }
        ],
        columns: [],
        total: 0,
        showIndex: true,
        mutiCheck: true,
        mutiFixed: 'left'
      },
      loading: false,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      height: 0,
      filterList: {
        search: '',
        companyId: '',
        invoiceDate: '',
        status: '',
        saleIds: ''
      },
      isActive: false,
      dialogVisible1: false,
      dialogVisible2: false,
      rowData: {},
      sortObj: {},
      selectionItem: [],
      userOptions: [],
      optLoading: false,
      referenceNumber: '',
      active: 0,
      drawer: false
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown']),
    companyOptions() {
      return this.companyDrapdown
    },
    totalAmount() {
      let sum = 0
      this.selectionItem.forEach((a) => {
        sum += +a.invoiceAmount
      })
      return sum.toFixed(2)
    },
    fileds() {
      const fileds = [...this.tableData.fileds]
      if (this.active === 1) {
        fileds.splice(1, 1, {
          filed: 'supplierName',
          label: '供应商',
          width: '230'
        })
      }
      return fileds
    }
  },
  activated() {
    this.getList(this.pager)
  },
  created() {
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
    this.getUserList()
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
    this.getList(this.pager)
  },
  methods: {
    changeType(type) {
      this.active = type
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.selectionItem = []
      this.getList(param)
    },
    getUserList() {
      getSaleList().then((res) => {
        if (res.success) {
          const arr = []
          res.data.map((item) => {
            arr.push({
              value: item.id,
              label: item.nameCH
            })
          })
          this.userOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortObj,
            ...this.formatterFilter()
          }
        }
        let res
        if (this.active === 0) {
          res = await getPages(params)
        } else {
          res = await getSupplierPages(params)
        }
        if (res.success) {
          this.loading = false
          res.data.list && (this.tableData.columns = res.data.list)
          this.tableData.total = res.data.total
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    formatterFilter() {
      return {
        search:
          this.filterList.search !== '' ? this.filterList.search : undefined,
        saleIds:
          this.filterList.saleIds.length > 0
            ? this.filterList.saleIds
            : undefined,
        companyId:
          this.filterList.companyId !== ''
            ? this.filterList.companyId
            : undefined,
        status:
          this.filterList.status !== '' ? this.filterList.status : undefined,
        startDate:
          this.filterList.date !== ''
            ? this.filterList.invoiceDate[0]
            : undefined,
        endDate:
          this.filterList.date !== ''
            ? this.filterList.invoiceDate[1]
            : undefined
      }
    },
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = param
      this.reset()
      this.getList(param)
    },
    sendFilter() {
      if (
        this.filterList.search !== '' ||
        this.filterList.saleIds.length !== 0 ||
        this.filterList.invoiceDate !== '' ||
        this.filterList.status !== '' ||
        this.filterList.companyId !== ''
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    reset() {
      this.filterList = {
        search: '',
        companyId: '',
        invoiceDate: '',
        status: '',
        saleIds: ''
      }
      this.$refs.baseMutiInput.reset()
      this.isActive = false
    },
    handlePageChange(page) {
      this.pager = page
      this.getList(page)
    },
    sortChange(params) {
      this.sortObj = {
        sortField: params.prop,
        sortBy: params.order
      }
      this.getList(this.pager)
    },
    handleSelectionChange(items) {
      this.selectionItem = items
    },
    ok() {
      this.dialogVisible1 = false
      this.getList(this.pager)
    },
    // 审核
    async audit(row) {
      try {
        let result
        if (this.active === 1) {
          result = await reviewSupplierInvoice({ invoiceId: row.id })
        } else {
          result = await reviewInvoice({ invoiceId: row.id })
        }
        if (result.success) {
          this.getList(this.pager)
          this.$message.success(result.errorMessage)
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    reAudit(row) {
      this.$confirm('确定要撤销审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          let result
          if (this.active === 1) {
            result = await antiSupplierReviewInvoice({ invoiceId: row.id })
          } else {
            result = await antiReviewInvoice({ invoiceId: row.id })
          }
          if (result.success) {
            this.getList(this.pager)
            this.$message.success(result.errorMessage)
          } else {
            this.$message.error(result.errorMessage)
          }
        } catch (error) {
          console.error(error)
        }
      })
    },
    deleteRow(row) {
      this.$confirm('确定要删除客户账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          let result
          if (this.active === 1) {
            result = await deleteSupplierInvoice({ invoiceId: row.id })
          } else {
            result = await deleteCustomerInvoice({ invoiceId: row.id })
          }
          if (result.success) {
            this.getList(this.pager)
            this.$message.success(result.errorMessage)
          }
        } catch (error) {
          console.error(error)
        }
      })
    },
    async derive() {
      if (!this.selectionItem.length) {
        this.$message.warning('请选择导出行')
        return
      }
      if (this.selectionItem.length > 1) {
        this.$message.warning('导出只能选择一条')
        return
      }
      this.optLoading = true
      const params = {
        invoiceId: this.selectionItem[0].id
      }
      if (this.active === 1) {
        await derive('SupplierInvoice/downLoadInvoiceFile', 'get', params)
      } else {
        await derive('CustomerInvoice/downLoadInvoiceFile', 'get', params)
      }
      this.optLoading = false
    },
    detail(menuCode, row) {
      if (this.active === 1) {
        // menuCode = 'YHXM'
        this.rowData = row
        this.dialogVisible2 = true
      } else {
        const path = getRouteByCode(menuCode)
        // console.log(path, menuCode, btnCode)
        const params = {
          menuCode,
          queryJson: JSON.stringify({
            date: getRecentMonthDate(24),
            companyId: row.companyId,
            invoiceId: row.id
          })
        }
        this.$store.commit('SET_CONNNET', params)
        if (path !== this.$route.fullPath) {
          this.$router.push(path)
        }
      }
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.filterList.search = this.referenceNumber.join(',')
          const param = {
            pageIndex: 1,
            pageSize: 20
          }
          this.pagerConfig = param
          this.getList(param)
        }
        this.$refs.popover.doClose()
      }, 0)
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.filterList.search = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    showVerifedLog(row) {
      this.rowData = row
      this.drawer = true
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color: rgb(18, 88, 188);
    }
  }
  .opt {
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    & .generate {
      height: 30px;
      box-sizing: border-box;
      margin-right: 5px;
      border-radius: 4px;
      cursor: pointer;
    }
    & .derive {
      height: 30px;
      box-sizing: border-box;
      margin-right: 5px;
      border-radius: 4px;
      cursor: pointer;
    }
    .derive {
      width: 80px;
      border: 1px solid rgb(18, 88, 188);
      color: rgb(18, 88, 188);
    }
    .generate {
      width: 100px;
      border: 1px solid #35ba83;
      color: #35ba83;
    }
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 5px;
      color: #2c3e50;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    position: relative;
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    .custom-total {
      display: flex;
      position: absolute;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50px;
      background: #f7f7f7;
      border: 1px solid #eeeeee;
      border-top: 0;
      padding-left: 17px;
      padding-right: 40px;
      box-sizing: border-box;
      .select {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      .total {
        margin-left: 16px;
        font-size: 14px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        color: #333333;
        span {
          color: #fe453d;
          font-weight: bold;
        }
      }
    }
    .status {
      width: 60px;
      height: 26px;
      border-radius: 4px 4px 4px 4px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      margin: 0 auto;
    }
    .green {
      background: rgba(53, 186, 131, 0.1);
      color: #35ba83;
    }
    .red {
      background: rgba(255, 116, 68, 0.1);
      color: #ff7444;
    }
  }
  .table-opt {
    display: flex;
    justify-content: space-around;
    span {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
      & + span {
        margin-left: 20px;
      }
    }
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>
